<script>
import { displayToast, checkPermission, handleResponseError } from '@/components/utils/globalFunction'
import SelectStoreModal from '@/components/modal/repair-file/SelectStoreModal.vue'
import RecyclingReferentialService from '@/services/recyclingModule/RecyclingReferentialService'
import RecyclingFolderService from '@/services/recyclingModule/RecyclingFolderService'

export default {
  name: 'recyclingPage',
  components: { SelectStoreModal },
  data() {
    return {
      loading: false,

      selectedStore: null,

      storeBacList: [],
      recyclingFolderCount: 0,
      recyclingFolderReportPrice: 0
    }
  },
  async mounted() {
    const storeList = this.$store.getters['auth/getStoreListCollaborator']
    if (storeList.length > 1) {
      const response = await this.$refs.selectStoreModal.show({
        arrayList: storeList,
        title: this.$t('FILE_STEP_PRODUCT.STORE_MODAL.TITLE'),
        message: this.$t('FILE_STEP_PRODUCT.STORE_MODAL.MESSAGE'),
        placeHolder: this.$t('FILE_STEP_PRODUCT.STORE_MODAL.PLACEHOLDER'),
        validateButton: this.$t('COMMON.BUTTON.CONTINUE')
      })
      if (response.confirmed) {
        this.selectedStore = response.selection
        this.$store.commit('auth/setRepairFileStoreSelected', this.selectedStore)
      }
    } else {
      this.selectedStore = storeList[0]
      this.$store.commit('auth/setRepairFileStoreSelected', storeList[0])
    }

    await this.getRecyclingFolderCountByStore()
    await this.getRecyclingFolderPriceReportByStore()
    await this.getRecyclingBacListByStore()
  },
  computed: {},
  methods: {
    checkPermission,
    async getRecyclingBacListByStore() {
      this.loading = true
      try {
        const response = await RecyclingReferentialService.getRecyclingBacListByStore(
          this.selectedStore.boomerang_id)
        this.storeBacList = response.itemList
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async getRecyclingFolderCountByStore() {
      this.loading = true
      try {
        const response = await RecyclingFolderService.getRecyclingFolderCountByStore(
          this.selectedStore.boomerang_id)
        this.recyclingFolderCount = response.count
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async getRecyclingFolderPriceReportByStore() {
      this.loading = true
      try {
        const response = await RecyclingFolderService.getRecyclingFolderPriceReportByStore(
          this.selectedStore.boomerang_id)
        this.recyclingFolderReportPrice = response.totalPrice
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async collectionTrigger(storeBac) {
      this.loading = true
      try {
        await RecyclingFolderService.collectionTrigger(
          this.selectedStore.boomerang_id,
          storeBac.boomerangId
        )

        await this.getRecyclingFolderCountByStore()
        await this.getRecyclingFolderPriceReportByStore()
        await this.getRecyclingBacListByStore()

        displayToast(this.$t('RECYCLING_MODULE.RECYCLING_PAGE.MAIN.TABLE.COLLECTION_TRIGGER_SUCCESS'), 'success')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async downloadRecycledProductListPdf() {
      this.loading = true
      try {
        let response = null;
        let filename = ''
        const now_date = new Date().toLocaleDateString('fr-FR',
          { year: 'numeric', month: '2-digit', day: '2-digit' })

        response = await RecyclingFolderService.getRecyclingFolderReportByStore(
          this.selectedStore.boomerang_id)

        filename = 'export-dossier-recyclage-' + now_date + '.xlsx'

        if (response != null) {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <v-container fluid>
    <div class="d-flex flex-column flex-md-row justify-space-between">
      <h1>{{ $t('RECYCLING_MODULE.RECYCLING_PAGE.TITLE') }}</h1>
    </div>

    <v-card class="rounded-xl mt-4 d-flex-column" :border="false" :elevation="0">
      <v-row>
        <!--GREEN PART-->
        <v-col cols="12" md="3" class="d-flex flex-column justify-center align-center green-container">
          <!--LOGO + TITLE-->
          <v-row>
            <v-col class="d-flex flex-row align-center justify-start">
              <img src="@/assets/images/recycle_blanc.svg" alt="logo recycling"/>
              <h2 class="white-text bold ml-4">
                {{ $t('RECYCLING_MODULE.RECYCLING_PAGE.GREEN.TITLE') }}
              </h2>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <p class="white-text mb-4">
                {{ $t('RECYCLING_MODULE.RECYCLING_PAGE.GREEN.TEXT_1') }}
              </p>
              <p class="white-text">
                {{ $t('RECYCLING_MODULE.RECYCLING_PAGE.GREEN.TEXT_2') }}
              </p>
            </v-col>
          </v-row>
        </v-col>

        <!--MAIN PART-->
        <v-col cols="12" md="9" class="main-container">
          <!--TITLE + BUTTON-->
          <v-row>
            <v-col class="d-flex flex-row align-center justify-space-between" style="margin-bottom: 20px">
              <h2 class="bold">{{ $t('RECYCLING_MODULE.RECYCLING_PAGE.MAIN.TITLE') }}</h2>
              <v-btn
                class="boom-button"
                to="/recycling-module/create-folder-page"
                variant="outlined"
                v-if="checkPermission(['DISTRIBUTOR_RECYCLING_CREATE'])"
              >
                <v-icon icon="mdi-recycle" class="ml-2"/>
                {{ $t('RECYCLING_MODULE.RECYCLING_PAGE.BUTTON.NEW_RECYCLING_FOLDER') }}
              </v-btn>
            </v-col>
          </v-row>

          <!--REPORT-->
          <v-row class="report-container">
            <v-col cols="12" md="6">
              <v-card class="rounded-xl d-flex-column" :border="false" :elevation="1">
                <v-row>
                  <v-col cols="12" md="6">
                    <p>{{ $t('RECYCLING_MODULE.RECYCLING_PAGE.MAIN.REPORT.RECYCLER.TITLE') }}</p>
                    <h3 class="bold">{{ recyclingFolderCount }}</h3>
                  </v-col>
                  <v-col cols="12" md="6" class="d-flex flex-row align-center justify-end">
                    <div class="img-container">
                      <img src="@/assets/images/recycler_icon.svg" alt="logo recycling"/>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card class="rounded-xl d-flex-column" :border="false" :elevation="1">
                <v-row>
                  <v-col cols="12" md="6">
                    <p>{{ $t('RECYCLING_MODULE.RECYCLING_PAGE.MAIN.REPORT.BUYBACK.TITLE') }}</p>
                    <h3 class="bold">{{ recyclingFolderReportPrice }} €</h3>
                  </v-col>
                  <v-col cols="12" md="6" class="d-flex flex-row align-center justify-end">
                    <div class="img-container">
                      <img src="@/assets/images/recycler_icon.svg" alt="logo recycling"/>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <!--BAC-->
          <v-row>
            <v-col>
              <v-row>
                <v-col>
                  <h2 class="bold">
                    {{ $t('RECYCLING_MODULE.RECYCLING_PAGE.MAIN.BAC.TITLE') }}
                  </h2>
                </v-col>
              </v-row>

              <v-table ref="repairListTable"
                       :hover="true"
                       :fixed-header="true">
                <tbody>
                  <tr v-if="loading">
                    <td class="pa-8 pa-md-16 text-md-center" colspan="10">
                      {{ $t('RECYCLING_MODULE.RECYCLING_PAGE.MAIN.TABLE.LOADING') }}
                      <v-progress-linear
                        class="my-5"
                        color="#165039"
                        indeterminate
                      />
                    </td>
                  </tr>

                  <tr v-else-if="!storeBacList.length">
                    <td class="pa-8 pa-md-8 text-md-center" colspan="10">
                      {{ $t('RECYCLING_MODULE.RECYCLING_PAGE.MAIN.TABLE.EMPTY') }}
                      <div class="d-flex align-center justify-center mt-8">
                        <img src="@/assets/images/empty.svg" width="100" alt="Empty">
                      </div>
                    </td>
                  </tr>

                  <tr
                    v-for="storeBac of storeBacList"
                    v-else
                    :key="storeBac.technicalId">
                    <td class="custom-td">
                      {{ storeBac.recyclerName }}
                    </td>

                    <td class="custom-td">
                      <div class="d-flex flex-row align-center justify-center img-container">
                        <img :src="storeBac.recyclerLogoUrl" alt="logo recycler" class="logo" />
                      </div>
                    </td>

                    <td class="custom-td">
                      <div class="d-flex flex-row align-center justify-start progress-bar-container">
                        <v-progress-linear
                          :model-value="storeBac.fillingThreshold > 0 ? (storeBac.currentCount / storeBac.fillingThreshold) * 100 : 0"
                          :height="10"
                          rounded
                          color="light-green"
                          class="flex-grow-1 mr-2"
                        />
                        <span>{{ storeBac.currentCount }}/{{ storeBac.fillingThreshold }}</span>
                      </div>
                    </td>

                    <td class="custom-td">
                      <div class="d-flex flex-row align-center justify-end btn-container">
                        <v-btn
                          class="boom-button"
                          variant="outlined"
                          @click="collectionTrigger(storeBac)"
                          :disabled="storeBac.currentCount === 0
                           || !checkPermission(['DISTRIBUTOR_RECYCLING_UPDATE'])">
                          {{ $t('RECYCLING_MODULE.RECYCLING_PAGE.MAIN.TABLE.BUTTON') }}
                        </v-btn>
                      </div>
                    </td>
                  </tr>

                </tbody>
              </v-table>
            </v-col>
          </v-row>

          <!--Batteries condition document-->
          <v-row>
            <v-col class="d-flex flex-row align-center justify-start">
              <img src="@/assets/icons/download_icon.svg" alt="logo download"
                   class="mr-2" />
              <p class="text-decoration-underline">
                {{ $t('RECYCLING_MODULE.RECYCLING_PAGE.MAIN.BATTERIES.TITLE') }}
              </p>
            </v-col>
          </v-row>

          <!--List of recycled product document-->
          <v-row>
            <v-col class="d-flex flex-row align-center justify-start">
              <img src="@/assets/icons/download_icon.svg" alt="logo download"
                   class="mr-2 cursor-pointer"
                   @click="downloadRecycledProductListPdf()"
              />
              <p class="text-decoration-underline cursor-pointer"
                 @click="downloadRecycledProductListPdf()">
                {{ $t('RECYCLING_MODULE.RECYCLING_PAGE.MAIN.RECYCLED_PRODUCT_LIST.TITLE') }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-container>

  <SelectStoreModal ref="selectStoreModal"/>
</template>

<style scoped>
.v-container {
  padding: 32px;
}

.v-card {
  padding: 20px 5px 20px 20px;
}

.bold {
  font-weight: bold;
}

.green-container {
  background-color: #165039;
  margin: -10px 0 -10px -10px;
  padding: 20px 10px 20px 20px;

  .white-text {
    color: white;
  }
}

.main-container {
  padding: 10px 15px 10px 30px;

  .report-container {
    .v-card {
      padding: 20px;
    }

    .img-container {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;
      background-color: #efefef;
      border-radius: 20px;
      padding: 20px;
      width: 85px;
      height: 85px;
    }
  }

  .logo {
    max-width: 150px;
    max-height: 80px;
  }

  .btn-container, .progress-bar-container {
    min-width: 210px;
  }

  .img-container {
    min-width: 150px;
  }

  .custom-td {
    padding: 0 2px !important;
  }

}
</style>
